/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Too_ManyInputs */

const en_us2_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At most 6 days a week: the body grows while resting.`)
};

const pt_br2_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No máximo 6 dias por semana: o corpo cresce no descanso.`)
};

const es_419_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como máximo 6 días por semana: el cuerpo crece en el descanso.`)
};

const pt_pt2_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No máximo 6 dias por semana: o corpo cresce no descanso.`)
};

const fr_fr2_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 jours par semaine maximum : le corps progresse pendant le repos.`)
};

const de_de2_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstens 6 Tage pro Woche: Der Körper wächst in der Pause.`)
};

const it_it2_profile_editors_too_many = /** @type {(inputs: Profile_Editors_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al massimo 6 giorni a settimana: il corpo cresce mentre riposa.`)
};

/**
* | output |
* | --- |
* | "At most 6 days a week: the body grows while resting." |
*
* @param {Profile_Editors_Too_ManyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_too_many = /** @type {((inputs?: Profile_Editors_Too_ManyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Too_ManyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_too_many(inputs)
	if (locale === "es-419") return es_419_profile_editors_too_many(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_too_many(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_too_many(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_too_many(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_too_many(inputs)
	return en_us2_profile_editors_too_many(inputs)
});
export { profile_editors_too_many as "profile-editors.too_many" }